import styles from "./styles.module.scss";

export const TracerButtons = ({
  tracerBtns,
  handleClickTracerBtn,
  isSideMenuExpanded,
}) => {
  return (
    <div className={styles.tracerBtnsContainer}>
      {tracerBtns.map((btnData) => {
        const BtnIcon = btnData.icon;
        const iconFillcolor = btnData.active ? "#006ab3" : "#666666";
        return (
          <div
            title={btnData.title}
            style={{ border: btnData.active && "2px solid #006ab3" }}
            key={btnData?.key}
            className={styles.tracerBtnContainer}
            onClick={() => handleClickTracerBtn(btnData)}
          >
            <BtnIcon fillColor={iconFillcolor} />
            {/* <span className={styles.title}>{btnData.title}</span> */}
          </div>
        );
      })}
    </div>
  );
};
